import axiosInstance from './axiosInstance';

export interface TaskFileInfo {
  url: string;
  filename: string;
  mimetype: string;
  size: number;
  originalname: string;
  fileDescription?: string;
  uploadedAt: string;
  uploader: string;
}

// Save a file uploaded via Cloudinary widget to a task
export const saveCloudinaryTaskFile = async (
  taskId: string,
  fileInfo: Omit<TaskFileInfo, 'uploadedAt' | 'uploader'>
) => {
  // The backend should accept this info and add it to the task's files array
  return axiosInstance.post(`/tasks/${taskId}/files/cloudinary`, fileInfo);
};
